import { StringHelper } from "../Helpers/StringHelper";
import { Property } from "../RadObject";
import { IPropertyComparer, PropertyComparer, PropertyComparerPropertyValues } from "./PropertyComparer";
import { NAMESPACE } from "./_Namespace";

export type PropertyComparerHasNoValuePropertyValues =
    PropertyComparerPropertyValues
    & {
    };

export type PropertyComparerHasNoValueProperties = {
    [name in keyof PropertyComparerHasNoValuePropertyValues]: Property<PropertyComparerHasNoValuePropertyValues[name]>
};

export interface IPropertyComparerHasNoValue extends IPropertyComparer, PropertyComparerHasNoValueProperties
{
}

export class PropertyComparerHasNoValue extends PropertyComparer<PropertyComparerHasNoValuePropertyValues> implements IPropertyComparerHasNoValue
{
    public static override classNamespace = NAMESPACE + "PropertyComparerHasNoValue";
    public static override className = "PropertyComparerHasNoValue";

    // #region Overrides

    public override compare(propertyValue: any, constantValue: any): boolean
    {
        return propertyValue === undefined || propertyValue === null || StringHelper.isNullOrWhitespace(propertyValue.toString());
    }

    // #endregion
}

